// Garage Organization Article - JavaScript functionality

document.addEventListener('DOMContentLoaded', function() {
    // Initialize the application
    initializeApp();
});

function initializeApp() {
    // Add smooth scrolling to any anchor links
    //addSmoothScrolling();
    
    // Add reading progress indicator
    addReadingProgress();
       
    // Add print functionality
    addPrintSupport();
}

function addSmoothScrolling() {
    // Add smooth scrolling to any internal links
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

function addReadingProgress() {
    // Create a simple reading progress indicator
    const progressBar = document.createElement('div');
    progressBar.className = 'reading-progress';
    progressBar.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 0%;
        height: 4px;
        background-color: #B5272E;
        z-index: 1000;
        transition: width 0.3s ease;
        display: block;
    `;
    
    document.body.appendChild(progressBar);
    
    // Update progress on scroll
    window.addEventListener('scroll', function() {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight - windowHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        const progress = (scrollTop / documentHeight) * 100;
        progressBar.style.width = Math.min(progress, 100) + '%';
    });
}



function addPrintSupport() {
    // Add print styles and functionality
    window.addEventListener('beforeprint', function() {
        // Hide reading progress bar when printing
        const progressBar = document.querySelector('.reading-progress');
        if (progressBar) {
            progressBar.style.display = 'none';
        }
    });
    
    window.addEventListener('afterprint', function() {
        // Show reading progress bar after printing
        const progressBar = document.querySelector('.reading-progress');
        if (progressBar) {
            progressBar.style.display = 'block';
        }
    });
}


// Error handling
window.addEventListener('error', function(e) {
    // Only log actual errors, not generic "Script error" messages
    if (e.message !== 'Script error.') {
        console.error('Application error:', {
            message: e.message,
            filename: e.filename,
            lineno: e.lineno,
            colno: e.colno,
            error: e.error
        });
    }
});

// Console message for developers
console.log('Garage Organization Article loaded successfully!');
console.log('Article statistics:', {
    sections: document.querySelectorAll('.content-section').length,
    tags: document.querySelectorAll('.tag').length,
    readingTime: '8 minutes'
});